var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{key:_vm.text,attrs:{"content":_vm.text,"placement":"top-start","disabled":_vm.disableTooltip}},[_c('span',[_vm._v(_vm._s(_vm.trimmedText))])])}
var staticRenderFns = []

export { render, staticRenderFns }